import type { UsersArgs } from '@getaccept/lib-shared/src/users/types/users-args';

export const usersKeys = {
  all: ['users'] as const,
  lists: () => [...usersKeys.all, 'list'] as const,

  usersList: () => [...usersKeys.lists(), 'user-list'] as const,

  manageUsersLists: entityId => [...usersKeys.lists(), 'manage-users', entityId] as const,
  manageUsersList: (entityId: string, args: UsersArgs) =>
    [...usersKeys.manageUsersLists(entityId), args] as const,

  sesarchLists: entityId => [...usersKeys.lists(), 'search', entityId] as const,
  searchList: (entityId: string, search?: string) =>
    [...usersKeys.sesarchLists(entityId), search] as const,

  details: () => [...usersKeys.all, 'detail'] as const,
  detail: (id: string) => [...usersKeys.details(), id] as const,

  allUserProfiles: () => [...usersKeys.all, 'profileDetails'] as const,
  userProfiles: (userId: string) => [...usersKeys.allUserProfiles(), userId] as const,
  userProfile: (userId: string, entityId: string) =>
    [...usersKeys.userProfiles(userId), entityId] as const,

  emailExists: (entityId, email: string) =>
    [...usersKeys.all, 'emailExists', entityId, email] as const,

  userModuleAccess: (email: string) => [...usersKeys.all, 'userModuleAccess', email] as const,
};
